import React, { useEffect } from 'react';
import Hero from '../components/Hero';
import ServicesGrid from '../components/ServicesGrid';
import WhyStats from '../components/WhyStats';
import CoverageTestimonials from '../components/CoverageTestimonials';
import ContactForm from '../components/ContactForm';
import { FAQS } from '../mock';
import {
  Accordion, AccordionContent, AccordionItem, AccordionTrigger,
} from '../components/ui/accordion';
import useReveal from '../hooks/useReveal';

export default function Home() {
  useReveal();
  useEffect(() => { document.title = 'StreetFleet | Same-Day & Rush Courier Service in Toronto & the GTA'; }, []);

  return (
    <>
      <Hero />
      <ServicesGrid />
      <WhyStats />
      <CoverageTestimonials />

      <section className="py-20 bg-white">
        <div className="max-w-3xl mx-auto px-4 sm:px-6">
          <div className="text-center mb-10 reveal">
            <span className="text-[#17A2C4] font-bold uppercase tracking-wider text-sm">FAQ</span>
            <h2 className="text-3xl sm:text-4xl font-extrabold text-[#4E4E50] mt-2">Frequently asked questions</h2>
          </div>
          <Accordion type="single" collapsible className="reveal">
            {FAQS.map((f, i) => (
              <AccordionItem key={i} value={`item-${i}`}>
                <AccordionTrigger className="text-left font-bold text-[#4E4E50] hover:text-[#17A2C4]">{f.q}</AccordionTrigger>
                <AccordionContent className="text-gray-600">{f.a}</AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </section>

      <section id="contact" className="py-20 bg-[#f5f7f8]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <div className="text-center max-w-2xl mx-auto mb-12 reveal">
            <span className="text-[#17A2C4] font-bold uppercase tracking-wider text-sm">Get in touch</span>
            <h2 className="text-3xl sm:text-4xl font-extrabold text-[#4E4E50] mt-2">Request a pickup or quote</h2>
          </div>
          <div className="reveal"><ContactForm /></div>
        </div>
      </section>
    </>
  );
}
